import { render, staticRenderFns } from "./IndexPayment.vue?vue&type=template&id=48ad5bb4"
import script from "./IndexPayment.vue?vue&type=script&lang=js"
export * from "./IndexPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports